import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { Card, PageHeader, Button, Plus } from '@opendate-app/setlist';
import client from '../../../shared/api/client';
import CSVImporter, { FAN_IMPORT_CHUNK_SIZE, FAN_IMPORT_RETRY_HINT } from '../../CSVImporter/CSVImporter';
import AddFanSlidingPane from './AddFanSlidingPane';
import TopContactsCard from './TopContactsCard';
import EventTypesCard from './EventTypesCard';
import WhereFromCard from './WhereFromCard';
import ReachabilityCard from './ReachabilityCard';
import WhenTheyBuyCard from './WhenTheyBuyCard';
import MembersDonorsCard from './MembersDonorsCard';
import PotentialArtistFans from './PotentialArtistFans';
import AllContactsTable from './AllContactsTable';

const CSV_IMPORTER_KEY = '0d9b493c-be4f-4658-be6d-667932c979cd';

export default function FansDashboardPage({
  csrfToken,
  team,
  contactLabel,
  header,
  kpis,
  topContacts,
  insightsUrl,
  geoCoordinatesUrl,
  showPotentialArtistFans,
  canViewSegments,
  selectedArtist,
  table,
}) {
  const [insights, setInsights] = useState(null);
  const [insightsError, setInsightsError] = useState(false);
  const [addAFanIsOpen, setAddAFanIsOpen] = useState(false);

  useEffect(() => {
    let ignore = false;
    client.get(insightsUrl)
      .then((res) => { if (!ignore) setInsights(res.data); })
      .catch(() => { if (!ignore) setInsightsError(true); });
    return () => { ignore = true; };
  }, [insightsUrl]);

  return (
    <div style={{ paddingBottom: 20 }}>
      <ToastContainer icon={false} />
      <div style={{ marginBottom: 16 }}>
        <PageHeader
          title={header.label}
          supportingText={header.subtitle}
          actions={(
            <>
              <CSVImporter
                csrfToken={csrfToken}
                team={team}
                importerKey={CSV_IMPORTER_KEY}
                type="CSVImportRows::Fan"
                chunkSize={FAN_IMPORT_CHUNK_SIZE}
                retryHint={FAN_IMPORT_RETRY_HINT}
                renderAnchor={(openModal) => (
                  <Button variant="secondary" onClick={openModal}>Import</Button>
                )}
              />
              <Button variant="primary" icon={Plus} onClick={() => setAddAFanIsOpen(true)}>Add contact</Button>
            </>
          )}
        />
      </div>

      <style>{`
        .fdash-grid { display: grid; gap: 16px; margin-bottom: 16px; align-items: stretch; }
        .fdash-grid > * { height: 100%; }
        .fdash-grid-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
        .fdash-grid-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
        .fdash-grid-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        @media (max-width: 1100px) {
          .fdash-grid-3, .fdash-grid-2 { grid-template-columns: 1fr; }
          .fdash-grid-4 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        }
        @media (max-width: 640px) {
          .fdash-grid-4 { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="fdash-grid fdash-grid-4">
        {kpis.map((k) => (
          <Card key={k.key} padding="md">
            <div style={{ fontSize: 14, fontWeight: 600 }}>{k.label}</div>
            <div style={{ fontSize: 30, fontWeight: 700 }}>{k.value}</div>
            <div style={{ fontSize: 12, color: 'var(--sl-text-quaternary, #717680)' }}>{k.note}</div>
          </Card>
        ))}
      </div>

      <div className="fdash-grid fdash-grid-3">
        <TopContactsCard topContacts={topContacts} contactLabel={contactLabel} />
        <EventTypesCard insights={insights} insightsError={insightsError} canViewSegments={canViewSegments} contactLabel={contactLabel} />
        <WhenTheyBuyCard insights={insights} insightsError={insightsError} />
      </div>

      <div className="fdash-grid fdash-grid-2">
        <WhereFromCard insights={insights} insightsError={insightsError} geoCoordinatesUrl={geoCoordinatesUrl} />
        <ReachabilityCard insights={insights} insightsError={insightsError} />
        {insights && insights.members_donors && insights.members_donors.enabled && (
          <MembersDonorsCard membersDonors={insights.members_donors} />
        )}
        {showPotentialArtistFans && (
          <PotentialArtistFans team={team} selectedArtist={selectedArtist} />
        )}
      </div>

      <div style={{ marginTop: 16 }}>
        <AllContactsTable table={table} contactLabel={contactLabel} />
      </div>

      <AddFanSlidingPane
        csrfToken={csrfToken}
        team={team}
        addAFanIsOpen={addAFanIsOpen}
        setAddAFanIsOpen={setAddAFanIsOpen}
      />
    </div>
  );
}
